import { message } from "antd";
import axiosInstance from "../shared/axios";

// GET
const getPostSessions = async (params) => {
  try {
    let result = await axiosInstance.get("/postSessionInstructions/viewAll", {
      params,
    });

    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("Error while loading sessions");
      return null;
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading sessions",
    );
    return null;
  }
};

const getPostSessionSingle = async (id) => {
  try {
    let result = await axiosInstance.get(`/postSessionInstructions/edit/${id}`);

    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("Error while loading post instruction");
      return null;
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading post instruction",
    );
    return null;
  }
};

const addEditPostSessionInstruction = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      id ? "/postSessionInstructions/update" : "/postSessionInstructions/store",
      { ...payload, id: id || null },
    );

    // Accept any 2xx status
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to save post-session instructions",
    };
  }
};

const deletePostSessionInstruction = async (id) => {
  try {
    const result = await axiosInstance.delete(
      `/postSessionInstructions/delete/${id}`,
    );

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to delete post-session instruction",
    };
  }
};

export const postsessioninstruction = {
  getPostSessions,
  addEditPostSessionInstruction,
  deletePostSessionInstruction,
  getPostSessionSingle,
};
